export const REQ_TIREBRANDS_SUCCESS = "REQ_TIREBRANDS_SUCCESS"
export const REQ_TIREDBRANDS_MIN_SUCCESS = "REQ_TIREBRANDS_MIN_SUCCESS"